import moment from 'moment'

window.setDefaultNull = function (value, value2) {
  if (
    typeof value !== 'undefined' &&
    value !== '' &&
    value !== null
  ) return value
  else if (value2 !== undefined) return value2
  else return null
}

window.consoleLog = function (value) {
  if (process.env.NODE_ENV === 'development') {
    return console.log(value)
  }
}

window.setUrlParams = function (arrParams) {
  var urlQuery = {}
  Object.keys(arrParams).map(function (param) {
    if (
      param !== 'byColumn' &&
      arrParams[param] !== null &&
      arrParams[param] !== ''
    ) {
      if (param === 'orderBy') {
        urlQuery['order'] = arrParams[param]
      } else {
        urlQuery[param] = arrParams[param]
      }
    }
  })
  // check order param
  if (!urlQuery.hasOwnProperty('order')) delete urlQuery['ascending']
  return urlQuery
}

window.setDetailValue = function (model, data) {
  var keys = Object.keys(data)
  for (let i = 0; i < keys.length; i++) {
    if (model[keys[i]] === undefined) continue
    if (typeof model[keys[i]] === 'object' && model[keys[i]] !== null) {
      if (data[keys[i]] !== null) {
        model[keys[i]].value = window.setDefaultNull(data[keys[i]], '')
      }
    } else {
      if (
        // keys[i].indexOf('Time') !== -1 ||
        keys[i].indexOf('Date') !== -1 ||
        keys[i].indexOf('StartTime') !== -1 ||
        keys[i].indexOf('EndTime') !== -1 ||
        keys[i].indexOf('edAt') !== -1
      ) {
        model[keys[i]] = data[keys[i]] == null ? '-' : moment(data[keys[i]]).format(window.AppConfig.dateFormat) // eslint-disable-line
      } else if (
        keys[i].indexOf('dob') !== -1
      ) {
        model[keys[i]] = data[keys[i]] == null ? '-' : moment(data[keys[i]]).format(window.AppConfig.shortDateFormat) // eslint-disable-line
      } else {
        model[keys[i]] = window.setDefaultNull(data[keys[i]], '-')
      }
    }
  }
}

window.setEmptyForm = function (model) {
  let keys = Object.keys(model)
  for (let i = 0; i < keys.length; i++) {
    model[keys[i]].value = null
  }
}

window.goBack = function (self) {
  if (self.$route.query.redirect !== undefined) {
    self.$router.push(self.$route.query.redirect)
  } else {
    // console.log(self.$route.params)
    window.history.back()
    // self.$router.push(self.$route.matched[self.$route.matched.length - 2])
    // window.history.back()
    // self.$router.push(self.$route.matched[self.$route.matched.length - 2])
  }
}

window.ConvertSnakeCaseMesssage = function (str) {
  if ((str === null) || (str === '')) return false
  else str = str.toString()

  return str
    .replace('_', ' ')
    .replace(/\w\S*/g, function (txt) { return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase() })
}



// WEBPACK FOOTER //
// ./src/_public.js